import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, ChevronRight } from 'lucide-react';

export default function MaintenanceConfirmedPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F5F5F0] flex items-center justify-center px-4 py-16">
      <div className="max-w-lg w-full text-center">
        {/* Icon */}
        <div className="w-20 h-20 rounded-full bg-[#68caf1]/20 border-2 border-[#68caf1] flex items-center justify-center mx-auto mb-6">
          <Check className="w-10 h-10 text-[#68caf1]" />
        </div>

        <p className="text-[#68caf1] text-xs font-bold uppercase tracking-widest mb-3">Booking Confirmed</p>
        <h1 className="text-3xl font-bold text-[#111827] mb-4">You're in.</h1>
        <p className="text-[#6B7280] text-base leading-relaxed mb-8">
          Your deposit is confirmed and your Alchemist Reset is locked in.
          A confirmation email is on its way — check your inbox.
        </p>

        {/* What to expect */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 text-left mb-6 space-y-4">
          <p className="text-xs font-bold text-[#68caf1] uppercase tracking-widest">What Happens Next</p>
          <div className="flex gap-3">
            <div className="w-6 h-6 rounded-full bg-[#68caf1] flex items-center justify-center text-black font-bold text-xs flex-shrink-0 mt-0.5">1</div>
            <div>
              <p className="text-sm font-bold text-[#111827]">Alchemist Reset — your first visit</p>
              <p className="text-sm text-[#6B7280]">Full steam, deep carpet & seat shampoo, windows, UV protect. We bring your interior to pristine.</p>
            </div>
          </div>
          <div className="flex gap-3">
            <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-bold text-xs flex-shrink-0 mt-0.5">2</div>
            <div>
              <p className="text-sm font-bold text-[#111827]">Balance collected at service</p>
              <p className="text-sm text-[#6B7280]">Akeem will collect the remaining 50% balance the day of your reset.</p>
            </div>
          </div>
          <div className="flex gap-3">
            <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-bold text-xs flex-shrink-0 mt-0.5">3</div>
            <div>
              <p className="text-sm font-bold text-[#111827]">Monthly maintenance begins — same address, every month</p>
              <p className="text-sm text-[#6B7280]">Vacuum, wipe-down, spot steam, windows. Flat rate — Sedan $75 · SUV $80 · Truck $85.</p>
            </div>
          </div>
        </div>

        <div className="bg-[#111827] rounded-2xl p-5 text-left mb-8">
          <p className="text-[#68caf1] text-xs font-bold uppercase tracking-widest mb-2">Reminder</p>
          <p className="text-white text-sm leading-relaxed">
            Please remove all personal items, valuables, and car seats before Akeem arrives so your detail can start on time.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate('/')}
            className="w-full bg-[#68caf1] text-black font-bold py-3.5 rounded-2xl hover:bg-[#5bb8db] transition-all active:scale-95 flex items-center justify-center gap-2"
          >
            Back to Home <ChevronRight className="w-4 h-4" />
          </button>
          <button
            onClick={() => navigate('/maintenance')}
            className="w-full bg-white border border-gray-200 text-[#374151] font-semibold py-3.5 rounded-2xl hover:border-[#68caf1] transition-all text-sm"
          >
            View Your Maintenance Program
          </button>
        </div>

        <p className="text-xs text-[#9CA3AF] mt-6">
          Questions? Reply to your confirmation email or text Akeem at (301) 885-9767.
        </p>
      </div>
    </div>
  );
}
